import { ReactNode, createContext, useContext } from 'react';

// Off without a provider, so a table rendered outside the app shell never
// sorts while the flag is off.
const TableSortingContext = createContext(false);

interface Props {
    enabled: boolean;
    children: ReactNode;
}

/**
 * Whether column-header sorting is on for every table below it. The app root
 * feeds it the `table_sorting_EOL1851` flag; tests and stories set it directly,
 * so they need no `@/lib/api` mock.
 */
export function TableSortingProvider({ enabled, children }: Props) {
    return (
        <TableSortingContext.Provider value={enabled}>
            {children}
        </TableSortingContext.Provider>
    );
}

export function useTableSortingEnabled(): boolean {
    return useContext(TableSortingContext);
}
